import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { UtilsService } from '../../services/utils.service';


@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss'],
  standalone: false
})
export class MenusComponent implements OnInit {
  headerTabs: any;
  isHeaderTabVisible: boolean = false;
  typeSelected: string;
  userName: any;
  userId: string;
  platformApiUrl: any;
  isShowProfilecard: boolean = false;
  moduleByteMap: any;
  response: any;
  allHeadersTab: any = [];
  iconHeaders: any = [];
  sideHeaders: any = [];
  platformUrl: any;
  headerTabsObs: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  moduleBytes = new BehaviorSubject<any>('');



  constructor(
    public auth: AuthService,
    private readonly spinner: NgxSpinnerService,
    private readonly http: HttpClient,
    private readonly utilService: UtilsService,
  ) {
    this.typeSelected = 'ball-clip-rotate-pulse';


    this.platformUrl = this.utilService.getDmaintPlatformURL();
    this.platformApiUrl = this.utilService.getDmintPlatformAPI();

  }

  ngOnInit(): void {
    this.spinner.show();
    const userId = sessionStorage.getItem('userId');
    if (userId != undefined) {

      this.headerTabsObs.subscribe((headers) => {
        if (headers == undefined || headers.length == 0) this.getHeaders(userId);
        else this.allHeadersTab = headers;
      });

      /*this.moduleBytes.subscribe((moduleBytes) => {
        if (moduleBytes == undefined || moduleBytes.length == 0) this.downloadImages();
        else this.moduleByteMap = moduleBytes as Object;
      }); */
    }

    this.auth.user$.subscribe((user) => {
      this.userName = user?.name;
    });
  }

  getHeaders(userId: any) {
    let parentToken = sessionStorage.getItem('parentToken');
    let authId = sessionStorage.getItem('id');
    if (null !== parentToken) {
      let menuHeaders: HttpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer `.concat(parentToken))
        .set('authId', authId)
        .set('userId', userId);


      this.http
        .post<any>(`${this.platformApiUrl}/v1/platformInfo`, null, {
          headers: menuHeaders,
        })
        .subscribe((res: any) => {
          const headerResult = res.result.headers;
          this.allHeadersTab = headerResult;
          this.setHeaderTabs(this.allHeadersTab);

          this.moduleByteMap = res.result.moduleImageBytes as Object;
          this.setModuleByte(this.moduleByteMap);

          this.allHeadersTab.forEach((header: any) => {

            if (header.homePageItem) {
              if (header.menuImagePath.includes('_icon.'))
                this.iconHeaders.push(header);
              else
                this.headerTabs.push(header);
            }
            else
              this.sideHeaders.push(header);
          });

          this.spinner.hide();

        });
    }
  }

  downloadImages() {
    this.http
      .get<Blob>(`${this.platformApiUrl}/v1/downloadAllCapabilityImages`)
      .subscribe((res) => {
        this.response = res;
        this.moduleByteMap = this.response.result as Object;
        this.setModuleByte(this.moduleByteMap);
      });
  }

  openLink(link: any) {
    window.open(`${link}`, '_blank');
  }

  logout() {
    this.spinner.hide();
    sessionStorage.clear();
    this.auth.logout();
  }

  onLoginCall() {
    this.auth.loginWithRedirect();
  }

  onShowUserProfile() {
    this.isShowProfilecard = !this.isShowProfilecard;
  }

  setHeaderTabs(headerTabs: any) {
    this.headerTabsObs.next(headerTabs);
  }
  setModuleByte(moduleBytesMap: any) {
    this.moduleBytes.next(moduleBytesMap);
  }
}
